<marv-item>
    <div class="content_item" (click)="this.togglePeople()">
        <app-operation-logo [operation]="this.operationLogo"/>
        <div class="operation_item_name">{{this.permanentOperation.name}}</div>
        <div class="operation_item_toggle">
            @if(this.isOpened){
                <ion-icon name="caret-up-outline"></ion-icon>
            }
            @else{
                <ion-icon name="caret-down-outline"></ion-icon>
            }
        </div>
    </div>
    @if(this.isOpened){
    <div class="content_agents">
        <div class="content_agents_title">
            <ion-icon name="people-outline"></ion-icon>{{'MY_AGENTS' | translate}}            
        </div>
        <div class="content_agents_list">
            @if(this.permanentsAgentsItems.length > 0){
                @for(permanentAgentItem of this.permanentsAgentsItems; track permanentAgentItem.id){
                    <app-permanent-agent-item [permanentOperation]="this.permanentOperation" [permanentAgent]="permanentAgentItem"/>
                }                
            }
            @else{
                <marv-message type="info">{{'MSG_NO_AGENT' | translate}}</marv-message>
            }
        </div>
    </div>
    }
</marv-item>
